import { OptionType } from "../../controlpanel";

export const ACTION_FABRIC_LIBRARY_VISIBILITY = 'fabric_library_visible';
export const ACTION_FABRIC_TILES = 'fabric_tiles_fetch';
export const ADD_FABRIC_LIST = 'fabric_add_list';

export const switchFabricSelectorVisibility = (visible: boolean, selOptionType?: OptionType, parentWindowScroll?: number|null) => ({
    type: ACTION_FABRIC_LIBRARY_VISIBILITY,
    payload: { visible, selOptionType, parentWindowScroll }
})

export const addFabricList = (theFabricList:any)=>({
    type: ADD_FABRIC_LIST,
    payload: {
        theFabricList
    }
})